import { Card, Icon } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { getProjectPath, ProjectPath } from '@utils/getMenuContent';
import { useSummaryCards } from '@pages/project/summary/_utils/contexts/SummaryCardsContext';
import { SummaryCardTitle } from './components/SummaryCardTitle';
import s from './SummaryCards.module.scss';
import { SummaryCardContent } from './components/SummaryCardContent';

export interface TraCardProps {
    pid: string;
}

export function TraCard(props: TraCardProps): ReactNode {
    const { pid } = props;
    const { data } = useSummaryCards();

    const totalCount = data?.trasCount ?? 0;
    const inProgressCount = data?.trasInProgressCount ?? 0;
    const readyForApprovalCount = data?.trasReadyForApprovalCount ?? 0;

    return (
        <Card
            title={
                <SummaryCardTitle
                    icon="health_and_safety"
                    title="Threat & Risk Analysis"
                    iconClassName={s.traIcon}
                />
            }
            cardClassName={s.card}
            foldable={false}
        >
            <SummaryCardContent
                content={
                    <div className="flex flex-column gap-2">
                        <h2 className="text-white">{totalCount}</h2>
                        <span className="text-white">
                            <strong>
                                {readyForApprovalCount}/{totalCount}
                            </strong>{' '}
                            Completed
                        </span>
                    </div>
                }
                footer={
                    <div className="flex gap-2">
                        <div className="flex gap-2 align-items-center">
                            <Icon name="chronic" className={s.statusIcon} />
                            <strong className="text-white">
                                {inProgressCount}
                            </strong>
                        </div>
                        <div className="flex gap-2 align-items-center">
                            <Icon name="preliminary" className={s.statusIcon} />
                            <strong className="text-white">
                                {readyForApprovalCount}
                            </strong>
                        </div>
                    </div>
                }
                navigationLabel="See all"
                to={getProjectPath(ProjectPath.Tra, pid)}
            />
        </Card>
    );
}
